import { Link, Typography } from '@mui/material'
import './Copyright.css';

const Copyright = () => {
    return (
        <Typography
            variant="body2"
            className='footer'>
            {'Copyright © '}
            <Link color="inherit" href="https://www.outsourcia.com/">
                Outsourcia
            </Link>{' '}
            {'2023'}
        </Typography>
    );
};

export default Copyright;